<script>
import { connect } from 'vuex-connect';
import StatusBox from '../scenes/StatusBox.vue';

export default connect({
  gettersToProps: {
    station: 'currentStation',
    canStart: 'canStart',
    hasCalledHelp: 'hasCalledHelp',
  },
  stateToProps: {
    loading: state => state.launcher.loadings.getStation,
  },
  actionsToEvents: {
    'switch-game': 'donePlaying',
    'hide-dashboard': 'hideDashboard',
    'done-playing': 'donePlaying',
    'volume-change': 'setAudio',
  },
  lifecycle: {
    created ({ dispatch }) {
      // dispatch('getStation')
    },
  },
})('StatusBox', StatusBox);
</script>
